import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Instant Download', 'No Subscription', 'Lifetime Access', '30-Day Guarantee'];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-ink px-5 pb-16 pt-10 sm:pt-14" data-id="element-107" data-mp="9lla0zpw82ok">
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-px bg-lime/40" data-id="element-108" data-mp="4mrxpamcehpz" />
      <div className="relative mx-auto max-w-4xl text-center" data-id="element-109" data-mp="128pgza8jqr2z">
        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-[11px] font-bold uppercase tracking-[0.24em] text-lime" data-id="element-110" data-mp="xbfk59itvd54">
          The Complete Coaching System
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mt-4 font-display text-[2.35rem] font-extrabold uppercase leading-[0.96] text-white sm:text-5xl md:text-[3.75rem]" data-id="element-111" data-mp="3d2bkbqsid1w2">
          Solve a Full Year of Football Training in Just{' '}
          <span className="text-lime" data-id="element-112" data-mp="39aupl8xknev4">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-113" data-mp="39cpa4m4xl4yo">
          Join 2,000+ football coaches who stopped improvising. Walk onto the
          pitch with everything ready to coach, lead, and win.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.18,
        ease: 'easeOut'
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-114" data-mp="2vi55xb5imm16">
          <img src="https://cdn.magicpatterns.com/uploads/mbqQFY4dKtUo2bqKopn9us/Diseno-sin-titulo-2026-08-03T205333.727.webp" alt="The Football Ready pack shown across 6 printed volumes, desktop, tablet and phone" className="w-full" data-id="element-115" data-mp="2ljz0wkoewzs3" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.28,
        ease: 'easeOut'
      }} className="mt-4" data-id="element-116" data-mp="ia5i8v83qdt4">
          <CtaButton href="#offer" data-id="element-117" data-mp="1ayjg9az6xa4o" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-white/45 sm:text-sm" data-id="element-118" data-mp="161jal16969e3">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-119" data-mp="x1nv4k5nzs89" data-mpi={index}>
                <span data-id="element-120" data-mp="x37falufynfb">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-white/25" data-id="element-121" data-mp="3lu9tqr7n9g6h">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}